/**
 * Consistent error formatting for admin/finance API responses.
 * Handles FastAPI-style detail (string, array of {msg,loc}, or dict).
 */
export function formatApiError(err) {
  if (!err) return "Unknown error";
  const d = err?.response?.data;
  const detail = d?.detail;
  if (typeof d === "string") return d;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((x) =>
      typeof x === "string" ? x : (x?.msg || JSON.stringify(x))
    ).join("; ");
  }
  if (detail && typeof detail === "object") {
    return detail.msg || JSON.stringify(detail);
  }
  if (err?.message) return err.message;
  return "Request failed";
}
